// @flow
import {createSelector} from "reselect";
import type {State} from "../../Store";

const originAutocompleteSelector = (state: State) => state.originAutocomplete;

const originAutocompleteAddress = createSelector(
    originAutocompleteSelector,
    (originAutocomplete) => {
        return originAutocomplete.address;
    }
);

export default {
    originAutocompleteSelector,
    originAutocompleteAddress,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/OriginAutocomplete/selectors.js